import { useAppSelector } from '../../../store/hooks/hooks';
import { Marker } from 'react-map-gl';
import './MapUserLocation.less';

function MapUserLocation() {
  const location = useAppSelector(state => state.map.userLocation);

  if (!location)
    return null;

  return (
    <Marker
      longitude={location.longitud}
      latitude={location.latitud}

    >
      <div className='at-map-user-location__point'/>
    </Marker>
  );
}

export default MapUserLocation;
